import React from "react";
import LegalLayout, { Section, Bullets } from "@/components/LegalLayout";

const CONTACT = "privacy@karyowads.com";

export default function CookiePolicy() {
  return (
    <LegalLayout
      title="Cookie Policy"
      subtitle="This Cookie Policy explains how KARYOW AI Ads Manager uses cookies and similar technologies at karyowads.com."
      lastUpdated="June 1, 2026"
    >
      <Section title="1. What Are Cookies?">
        <p>
          Cookies are small text files placed on your device when you visit a website. They are widely used to
          make sites work, remember your preferences, and provide information to site owners. We also use similar
          technologies such as local storage and pixels, which we refer to collectively as "cookies".
        </p>
      </Section>

      <Section title="2. How We Use Cookies">
        <p>KARYOW AI Ads Manager uses cookies to:</p>
        <Bullets items={[
          "Keep you signed in and maintain your session securely.",
          "Remember your workspace, brand, and interface preferences.",
          "Understand how the Service is used so we can improve performance and features.",
          "Protect against fraud and secure your account.",
        ]} />
      </Section>

      <Section title="3. Types of Cookies We Use">
        <div className="space-y-4">
          <div className="rounded-xl border border-[#242B30] bg-[#14181B] p-4">
            <div className="font-mono text-[11px] tracking-[0.16em] uppercase text-lime-400">Strictly Necessary</div>
            <p className="mt-2">
              Required for the Service to function, including authentication, session management, and security.
              These cannot be switched off in our systems.
            </p>
          </div>
          <div className="rounded-xl border border-[#242B30] bg-[#14181B] p-4">
            <div className="font-mono text-[11px] tracking-[0.16em] uppercase text-lime-400">Preferences</div>
            <p className="mt-2">
              Remember choices you make, such as your brand settings, currency, and layout preferences, to
              personalize your experience.
            </p>
          </div>
          <div className="rounded-xl border border-[#242B30] bg-[#14181B] p-4">
            <div className="font-mono text-[11px] tracking-[0.16em] uppercase text-lime-400">Analytics</div>
            <p className="mt-2">
              Help us understand usage patterns and improve the platform. This data is aggregated and used to
              enhance functionality and reliability.
            </p>
          </div>
        </div>
      </Section>

      <Section title="4. Third-Party Cookies">
        <p>
          Some cookies may be set by third-party services we use, such as authentication providers and
          infrastructure partners, to deliver core functionality. These providers process data according to their
          own privacy policies.
        </p>
      </Section>

      <Section title="5. Managing Your Cookie Preferences">
        <p>
          Most browsers let you control cookies through their settings, including blocking or deleting them. Please
          note that disabling strictly necessary cookies may prevent parts of the Service from working, including
          keeping you signed in. Consult your browser's help documentation for instructions on managing cookies.
        </p>
      </Section>

      <Section title="6. Changes to This Cookie Policy">
        <p>
          We may update this Cookie Policy from time to time to reflect changes in technology or law. Updates will
          be posted on this page with a revised "Last updated" date.
        </p>
      </Section>

      <Section title="7. Contact">
        <p>
          If you have questions about our use of cookies, contact us at{" "}
          <span className="text-lime-400">{CONTACT}</span>.
        </p>
      </Section>
    </LegalLayout>
  );
}
